import { checkboxSizes } from "@insite/mobius/Checkbox";
import { toggleSizes } from "@store/MobiusOverrides/Checkbox/ToggleInput";
import merge from "lodash/merge";

merge(checkboxSizes, {
    default: {
        iconSize: 18, // Icon size (px)
        fontSize: 15, // Font size for label (px)
        borderRadius: 3, // Border radius (px)
        // Custom Code
        borderWidth: 2, // Border size (px)
        boxSpacing: 10, // Spacing between the checkbox and the label (px)
        descriptionSpacing: 7, // Spacing between hint & error and field (px)
        itemSpacing: 10, // Spacing inbetween checboxes of a same group (px)
        offset: 2, // Offset to align the checkbox with the label (px)
        toggleOffset: 2, // Offset to align the toggle checkbox with the label (px)
    },
    small: {
        iconSize: 16,
        fontSize: 14,
        borderRadius: 2,
        // Custom Code
        borderWidth: 2,
        boxSpacing: 8,
        descriptionSpacing: 5,
        itemSpacing: 6,
        offset: 2,
        toggleOffset: 2,
    },
});

merge(toggleSizes, {
    default: {
        iconSize: 16,
        circleSize: 12,
        height: 20,
        width: 36,
        uncheckedOffset: -16,
    },
    small: {
        iconSize: 14,
        circleSize: 10,
        height: 16,
        width: 30,
        uncheckedOffset: -15,
    },
});
